import { DatePicker } from 'antd';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';

const BaseDatePicker = DatePicker.generatePicker<Date>(dateFnsGenerateConfig);

export default BaseDatePicker;
